var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { icons, utils } from "zebulon-controls";
import { computeRowSearch, rowSearch, cellSearch, getRegExp } from "./utils/compute.data";
export var Search = function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _initialiseProps.call(_this);

    var filteredData = props.filteredData,
        meta = props.meta,
        dataStrings = props.dataStrings,
        rowStartIndex = props.rowStartIndex,
        rowStopIndex = props.rowStopIndex;

    var properties = meta.properties.filter(function (property) {
      return !property.hidden;
    });
    _this.state = {
      dataStrings: computeRowSearch(filteredData, properties, dataStrings),
      value: "",
      properties: properties,
      cell: {},
      rowStartIndex: rowStartIndex,
      rowStopIndex: rowStopIndex
    };
    return _this;
  }

  _createClass(Search, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(
        "div",
        { style: { display: "flex" } },
        React.createElement("input", {
          style: { width: 200 },
          onChange: function onChange(e) {
            return _this2.handleChange(e);
          },
          value: this.state.value,
          autoFocus: true,
          ref: function ref(_ref) {
            return _this2.input = _ref;
          }
        }),
        React.createElement("div", {
          style: {
            background: icons.downArrow,
            backgroundSize: "cover",
            height: "1em",
            width: "1em",
            marginTop: "0.1em",
            marginRight: "0.1em"
          },
          onClick: function onClick() {
            return _this2.handleClickNext(1);
          }
        }),
        React.createElement("div", {
          style: {
            background: icons.upArrow,
            backgroundSize: "cover",
            height: "1em",
            width: "1em",
            marginTop: "0.4em",
            marginRight: "0.1em",
            zoom: 0.7
          },
          onClick: function onClick() {
            return _this2.handleClickNext(-1);
          }
        }),
        React.createElement("div", {
          style: {
            background: icons.close,
            backgroundSize: "cover",
            height: "1em",
            width: "1em",
            marginTop: "0.7em",
            zoom: 0.5,
            marginRight: "0.1em",
            marginLeft: ".6em"
          },
          onClick: this.props.onClose
        })
      );
    }
  }]);

  return Search;
}(Component);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleClickNext = function (direction) {
    var _state = _this3.state,
        cell = _state.cell,
        value = _state.value,
        rowIndexes = _state.rowIndexes,
        indexRowIndex = _state.indexRowIndex,
        properties = _state.properties;

    var exp = getRegExp(value);
    var cell_ = Object.assign({}, cell);
    var index = indexRowIndex;
    cell_.columns = cellSearch(_this3.props.filteredData[cell_.rows], properties, exp, cell_.columns + direction, direction);
    if (cell_.columns === null && (direction === 1 && index < rowIndexes.length - 1 || direction === -1 && index !== 0)) {
      index += direction;
      cell_.rows = rowIndexes[index];
      cell_.columns = cellSearch(_this3.props.filteredData[cell_.rows], properties, exp, direction === -1 ? properties.length - 1 : 0, direction);
    }
    if (cell_.columns !== null) {
      var cellRange = Object.assign({}, cell_, { columns: properties[cell_.columns].index_ });
      _this3.props.scrollTo(cellRange.rows, Math.sign(cellRange.rows - (_this3.state.cell.rows || 0)), cellRange.columns, Math.sign(cellRange.columns - (_this3.props.selectedCell.columns || 0)));
      _this3.setState({ cell: cell_, indexRowIndex: index });
    }
  };

  this.handleChange = function (e) {
    var value = e.target.value;
    var exp = getRegExp(value);
    var cell = { rows: undefined, columns: undefined };
    var ix = -1;
    if (!utils.isNullValue(value && value !== _this3.state.value)) {
      var _props = _this3.props,
          rowStartIndex = _props.rowStartIndex,
          rowStopIndex = _props.rowStopIndex,
          filteredData = _props.filteredData;

      var rows = _this3.state.dataStrings;
      var rowIndexes = rowSearch(rows, exp);
      _this3.setState({ value: value, rowIndexes: rowIndexes });
      if (rowIndexes.length) {
        ix = rowIndexes.findIndex(function (index) {
          return index >= rowStartIndex && index <= rowStopIndex;
        });
        if (ix === -1) {
          if (rowIndexes[rowIndexes.length - 1] > rowStopIndex) {
            ix = rowIndexes.findIndex(function (index) {
              return index > rowStopIndex;
            });
          } else {
            ix = rowIndexes.length - 1;
          }
        }
        cell.rows = rowIndexes[ix];
        var row = filteredData[cell.rows];
        cell.columns = cellSearch(row, _this3.state.properties, exp);
        var cellRange = Object.assign({}, cell, {
          columns: _this3.state.properties[cell.columns].index_
        });
        _this3.props.scrollTo(cellRange.rows, Math.sign(cellRange.rows - (_this3.props.selectedCell.rows || 0)), cellRange.columns, Math.sign(cellRange.columns - (_this3.props.selectedCell.columns || 0)), true);
      }
      _this3.setState({ value: value, rowIndexes: rowIndexes, cell: cell, indexRowIndex: ix });
    } else {
      _this3.setState({ value: value, rowIndexes: [], cell: cell, indexRowIndex: -1 });
    }
    _this3.input.focus();
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/Search.js
// module id = 349
// module chunks = 0